var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    staticClass: "home"
  }, [_c('Header', {
    attrs: {
      "isClassifyBtn": false
    }
  }), _c('div', {
    staticClass: "coupone-wrap content"
  }, [_c('ul', [_c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.isEmpity,
      expression: "!isEmpity"
    }]
  }, [_c('div', {
    staticClass: "desc"
  }, [_c('div', {
    staticClass: "price-wrap"
  }, [_c('span', {
    staticClass: "price-ago"
  }, [_vm._v("￥")]), _c('span', {
    staticClass: "price"
  }, [_vm._v(_vm._s(_vm.couponList.reduceMoney))])]), _c('div', {
    staticClass: "use-wrap"
  }, [_c('p', {
    staticClass: "type",
    attrs: {
      "title": _vm.couponList.activityName
    }
  }, [_vm._v(_vm._s(_vm.couponList.activityName))]), _vm.couponList.fullReduce > 0 ? _c('p', {
    staticClass: "use"
  }, [_vm._v("满" + _vm._s(_vm.couponList.fullReduce) + "元使用")]) : _c('p', {
    staticClass: "use"
  }, [_vm._v("无门槛券")])])]), _c('div', {
    staticClass: "useful-life"
  }, [_vm._v("有效期至：" + _vm._s(_vm._f("dateTimeFormatter")(_vm.couponList.useEndDate)))]), _vm.couponList.receive ? _c('img', {
    staticClass: "already-received",
    attrs: {
      "src": require("@/assets/images/already_received.png")
    }
  }) : _vm._e(), _c('div', {
    staticClass: "receive",
    class: {
      'no-receive': _vm.couponList.receive
    },
    on: {
      "click": function click($event) {
        return _vm.receiveCoupon(_vm.couponList);
      }
    }
  }, [_c('span', [_vm._v("点击领取")])])])])]), _c('BackTop'), _c('Footer')], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };